import React from 'react';
import { CheckIcon } from 'lucide-react';
const pains: string[] = ['Pasas de 40 minutos a 2 horas intentando dormirlo cada noche.', 'Se despierta 3, 4 o 5 veces y solo se calma en brazos.', 'Ya probaste mecerlo, la teta, el coche… y nada funciona igual dos noches seguidas.', 'Te sientes agotada, irritable y culpable por estarlo.'];
export function PainSection() {
  return <section className="w-full bg-slateblue-900 py-16 text-white sm:py-20" aria-labelledby="pain-title" data-id="element-59" data-mp="2l8m0xmhwypzz">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-60" data-mp="2q044mibbn4on">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slateblue-200" data-id="element-61" data-mp="2ba6cxse6nwup">
          Si estás leyendo esto a las 3 a.m., es para ti
        </p>
        <h2 id="pain-title" className="mt-4 font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-62" data-mp="2g9sn1sypswza">
          No es que tu bebé sea "difícil". Es que nadie te enseñó el orden
          correcto.
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-slateblue-200" data-id="element-63" data-mp="3rn0wrsnft8av">
          El sueño infantil no se arregla con trucos sueltos. Se arregla con una
          secuencia. Y esa secuencia se puede instalar en 72 horas.
        </p>
      </div>

      <ul className="mx-auto mt-10 grid max-w-4xl gap-3 px-5 sm:grid-cols-2" data-id="element-64" data-mp="5ehrj1m70dt0">
        {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-xl bg-white/5 p-4 text-left text-[15px] leading-relaxed text-slateblue-100 ring-1 ring-white/10" data-id="element-65" data-mp="h95gpxxbpmh">
            <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-coral" aria-hidden="true" data-id="element-66" data-mp="33z11qgj3evqh" />
            {pain}
          </li>)}
      </ul>
    </section>;
}